export const PHOTO_CAMERA_KEY = 'quest_photo_camera_v1';
export const DEFAULT_PHOTO_CAMERA = { mode: 'rear', deviceId: '' };

export function readPhotoCamera() {
  try {
    const value = JSON.parse(localStorage.getItem(PHOTO_CAMERA_KEY));
    if (value?.mode === 'usb' && typeof value.deviceId === 'string') {
      return { mode: 'usb', deviceId: value.deviceId };
    }
  } catch { /* 저장 제한 환경에서는 기본값으로 시작한다. */ }
  return DEFAULT_PHOTO_CAMERA;
}

export function savePhotoCamera(value) {
  try {
    localStorage.setItem(PHOTO_CAMERA_KEY, JSON.stringify({ mode: value.mode, deviceId: value.deviceId || '' }));
    return true;
  } catch { return false; }
}

export function photoCameraConstraints(camera = DEFAULT_PHOTO_CAMERA) {
  if (camera.mode === 'usb') {
    if (!camera.deviceId) throw new Error('SELECT_CAMERA');
    return { video: { deviceId: { exact: camera.deviceId } }, audio: false };
  }
  // 후면이 없는 PC에서 다른 장치를 후면으로 오인하지 않는다.
  return { video: { facingMode: { exact: 'environment' } }, audio: false };
}

export function photoCameraError(error) {
  const code = !error?.name || error.name === 'Error' ? error?.message : error.name;
  return ({
    SELECT_CAMERA: '대기화면에서 USB 카메라 장치를 선택해주세요.',
    NotAllowedError: '카메라 권한을 허용한 뒤 다시 시도해주세요.',
    SecurityError: '브라우저 또는 키오스크의 카메라 권한을 확인해주세요.',
    NotFoundError: '선택한 카메라가 없습니다. 연결을 확인하거나 대기화면에서 카메라를 바꿔주세요.',
    NotReadableError: '카메라를 열 수 없습니다. 다른 카메라 앱을 종료하고 연결을 확인해주세요.',
    OverconstrainedError: '선택한 카메라를 사용할 수 없습니다. 후면 카메라 지원 또는 USB 연결을 확인해주세요.',
    CAMERA_TIMEOUT: '카메라 준비가 지연되고 있습니다. 권한과 연결을 확인한 뒤 다시 시도해주세요.',
    CAMERA_DISCONNECTED: '카메라 연결이 끊어졌습니다. 다시 연결하거나 대기화면에서 카메라를 바꿔주세요.',
    NO_MEDIA_DEVICES: '이 환경에서는 카메라를 사용할 수 없습니다. HTTPS 접속과 브라우저 지원을 확인해주세요.',
    NATIVE_CAMERA_UNAVAILABLE: 'USB 카메라 지원 브릿지 앱 업데이트가 필요합니다. 앱 버전을 확인해주세요.',
  })[code] || '카메라를 열 수 없습니다. 연결을 확인한 뒤 다시 시도해주세요.';
}
